import * as React from "react";
import { StrapiPage } from "./Page";

interface DataProvider<T> {
  data: T;
  status: string;
  error: null | Error;
}

type StrapiPageState = DataProvider<{
  [slug: string]: StrapiPage;
}>;

type StrapiArticleState = DataProvider<{
  [slug: string]: any; // replace with StrapiArticle
}>;

const StrapiPageState = React.createContext<StrapiPageState>(undefined);
const StrapiPageDispatch = React.createContext<
  React.Dispatch<React.SetStateAction<StrapiPageState>>
>(undefined);

const StrapiArticleState = React.createContext<StrapiArticleState>(undefined);

export const Provider = ({ children }) => {
  const [pageState, setPageState] = React.useState<StrapiPageState>({
    data: {},
    status: "loading",
    error: null,
  });
  return (
    <StrapiPageDispatch.Provider value={setPageState}>
      <StrapiPageState.Provider value={pageState}>
        {children}
      </StrapiPageState.Provider>
    </StrapiPageDispatch.Provider>
  );
};

export const useStrapiPage = (slug: string) => {
  const ctx = React.useContext(StrapiPageState);

  const ctxRef = React.useRef(ctx);

  React.useEffect(() => {
    ctxRef.current = ctx;
  });

  const setPageState = React.useContext(StrapiPageDispatch);

  if (!ctx) {
    throw Error("useStrapiPage used outside Provider");
  }

  React.useEffect(() => {
    if (ctxRef.current.data[slug]) {
      return;
    }

    setPageState((prev) => ({
      ...prev,
      status: "loading",
    }));

    fetch(`http://localhost:1337/pages?slug=${slug}`)
      .then((res) => res.json())
      .then((data) => {
        setPageState((prev) => ({
          ...prev,
          status: "idle",
          data: {
            ...prev.data,
            [slug]: data,
          },
        }));
      });

    // fetch data
  }, [ctxRef, setPageState, slug]);

  return {
    ...ctx,
    data: ctx.data[slug],
  };
};
